import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import * as UserAttributesAPI from '../api/UserAttributesAPI';
import { ALL_USER_ATTRIBUTE_KEYS } from '../constants/UserAttributesKeys';
import { userIdSelector } from '../selectors/AuthSelectors';
import { allModifiedSettingsSelector } from '../selectors/SettingsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
function showSaveSuccessAlert() {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CrmSettingsTaskReminders.alert.saveSettingsSuccess.message"
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CrmSettingsTaskReminders.alert.saveSettingsSuccess.title"
    }),
    type: 'success',
    'data-test-id': 'follow-up-task-update-success'
  });
}
function showSaveFailureAlert(numFailures) {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CrmSettingsTaskReminders.alert.saveSettingsFailure.message"
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CrmSettingsTaskReminders.alert.saveSettingsFailure.title",
      options: {
        numFailures
      }
    }),
    type: 'danger'
  });
}
export const fetchSettings = createAsyncThunk('fetchSettings', (__arg, thunkAPI) => {
  const userId = userIdSelector(thunkAPI.getState());
  if (userId) {
    return UserAttributesAPI.bulkGet(ALL_USER_ATTRIBUTE_KEYS).catch(error => {
      Raven.captureException(error, {
        extra: {
          message: 'Error fetching user attributes'
        }
      });
      throw error;
    });
  }
  return Promise.resolve({});
});
export const saveModifiedSettings = createAsyncThunk('saveModifiedSettings', (__arg, thunkAPI) => {
  const modifiedAttributes = allModifiedSettingsSelector(thunkAPI.getState());
  return UserAttributesAPI.DANGEROUS_setAttributesBulk(modifiedAttributes).then(response => {
    const {
      results,
      error,
      errors
    } = response;
    if (error) {
      Raven.captureException(new Error('Error saving user attributes'), {
        extra: {
          message: 'Error saving user attributes'
        }
      });
      showSaveFailureAlert(errors.length);
    } else {
      showSaveSuccessAlert();
    }
    return results;
  });
});